/* BRILLA SKIN – script condiviso dalle sezioni "Brilla Skin" */
(function () {
  if (window.__brillaSkinLoaded) return;
  window.__brillaSkinLoaded = true;

  function pad(n) { return String(n).padStart(2, '0'); }

  function init(root) {
    root = root || document;

    // Galleria prodotto
    root.querySelectorAll('[data-px-gallery]:not([data-px-ready])').forEach(function (g) {
      g.setAttribute('data-px-ready', '');
      var track = g.querySelector('[data-px-slides]');
      var thumbs = g.querySelectorAll('[data-px-thumb]');
      if (!track) return;
      function current() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
      function mark(i) { thumbs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); }); }
      function go(i, smooth) { track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' }); mark(i); }

      // Miniature: clic = vai alla foto
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });

      // Scorrimento (dito, trackpad): aggiorna la miniatura attiva
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(current()); });
      }, { passive: true });

      // Trascinamento con il mouse (computer)
      var down = false, startX = 0, startLeft = 0, moved = 0;
      track.addEventListener('mousedown', function (e) {
        down = true; moved = 0; startX = e.pageX; startLeft = track.scrollLeft;
        track.classList.add('is-drag'); e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) {
        if (!down) return;
        moved = e.pageX - startX;
        track.scrollLeft = startLeft - moved;
      });
      window.addEventListener('mouseup', function () {
        if (!down) return;
        down = false; track.classList.remove('is-drag');
        var w = track.clientWidth, i = Math.round(startLeft / w);
        if (moved < -w * 0.15) i++; else if (moved > w * 0.15) i--;
        i = Math.max(0, Math.min(i, track.children.length - 1));
        go(i);
      });
    });

    // Offerte: aggiorna variante e quantità del form
    root.querySelectorAll('[data-px-offers]:not([data-px-ready])').forEach(function (box) {
      box.setAttribute('data-px-ready', '');
      var form = document.getElementById(box.getAttribute('data-px-offers'));
      var bundles = box.querySelectorAll('[data-px-bundle]');
      function select(b) {
        bundles.forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        if (!form) return;
        form.querySelector('input[name="id"]').value = b.getAttribute('data-variant');
        form.querySelector('input[name="quantity"]').value = b.getAttribute('data-qty');
      }
      bundles.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
      var on = box.querySelector('[data-px-bundle].is-on') || bundles[0];
      if (on) select(on);
    });

    // Countdown fino a mezzanotte
    root.querySelectorAll('[data-px-countdown]:not([data-px-ready])').forEach(function (el) {
      el.setAttribute('data-px-ready', '');
      function tick() {
        var n = new Date(), m = new Date(n); m.setHours(24, 0, 0, 0);
        var s = Math.floor((m - n) / 1000);
        el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      }
      tick(); setInterval(tick, 1000);
    });

    // Data di spedizione (prossimo giorno lavorativo + N giorni)
    root.querySelectorAll('[data-px-shipdate]:not([data-px-ready])').forEach(function (el) {
      el.setAttribute('data-px-ready', '');
      var add = parseInt(el.getAttribute('data-px-shipdate'), 10) || 0;
      var d = new Date(); d.setDate(d.getDate() + add);
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      el.textContent = d.toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' });
    });

    // Video: clic per audio on/off
    root.querySelectorAll('[data-px-video]:not([data-px-ready])').forEach(function (box) {
      box.setAttribute('data-px-ready', '');
      var v = box.querySelector('video');
      if (!v) return;
      v.muted = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
      var btn = box.querySelector('[data-px-sound]');
      box.addEventListener('click', function () {
        v.muted = !v.muted;
        if (!v.muted) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
        if (!btn) return;
        btn.querySelector('[data-px-ico-off]').style.display = v.muted ? '' : 'none';
        btn.querySelector('[data-px-ico-on]').style.display = v.muted ? 'none' : '';
        var lbl = btn.querySelector('[data-px-label]');
        if (lbl) lbl.textContent = v.muted ? btn.getAttribute('data-off') : btn.getAttribute('data-on');
      });
    });

    // Frecce carosello
    root.querySelectorAll('[data-px-scroll]:not([data-px-ready])').forEach(function (b) {
      b.setAttribute('data-px-ready', '');
      b.addEventListener('click', function () {
        var c = document.getElementById(b.getAttribute('data-target'));
        if (c) c.scrollBy({ left: parseInt(b.getAttribute('data-px-scroll'), 10), behavior: 'smooth' });
      });
    });

    // Barra fissa: compare dopo il pulsante principale
    root.querySelectorAll('[data-px-sticky]:not([data-px-ready])').forEach(function (bar) {
      bar.setAttribute('data-px-ready', '');
      var cta = document.querySelector('[data-px-cta]');
      if (!cta || !('IntersectionObserver' in window)) { bar.classList.add('is-show'); return; }
      new IntersectionObserver(function (e) {
        bar.classList.toggle('is-show', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
      }).observe(cta);
      var go = bar.querySelector('[data-px-goto]');
      if (go) go.addEventListener('click', function (ev) {
        var t = document.getElementById('px-offers');
        if (t) { ev.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Editor del tema: re-inizializza quando una sezione viene modificata
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
